import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteProductModel } from 'services/api/requests/productModel';
import { mapErrorToToastProps } from 'utils/forms/mapErrorToToastProps';

export const useDeleteProductModel = () => {
	const queryClient = useQueryClient();
	const toast = useToast();

	return useMutation(deleteProductModel, {
		onSuccess: sucess => {
			queryClient.invalidateQueries(['model-product']);
			queryClient.invalidateQueries(['model-product-list']);

			queryClient.refetchQueries(['model-product']);
			queryClient.refetchQueries(['model-product-list']);

			toast({
				title: 'Deletado com sucesso!',
				description: 'Modelo deletado com sucesso.',
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});
		},
		onError: (error: any, variables, context) => {
			const toastErrors: Array<any> = mapErrorToToastProps(
				error,
				'Erro ao deletar Modelo!'
			);
			toastErrors?.forEach(element => toast(element));
		},
	});
};
